import { FlexRow } from '@/components/common/Flex';
import { Paragraph } from '@/components/common/Typography';
import { Divider, FlexProps } from '@chakra-ui/react';

export const TransactionEntryDetailRow = ({
    label,
    children,
    divider = true,
    ...flexProps
}: {
    label: string;
    children: React.ReactNode;
    divider?: boolean;
} & FlexProps) => (
    <>
        <FlexRow
            justifyContent="space-between"
            align="center"
            gap={2}
            {...flexProps}
        >
            <Paragraph color="gray.500">{label}</Paragraph>
            {children}
        </FlexRow>
        {divider && <Divider py={2} mb={4} borderColor="border" />}
    </>
);
